import { combineReducers } from 'redux';
import albums from './albums/reducer';
import videos from './videos/reducer';

export default combineReducers({
  albums,
  videos,
});
